import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import EnterLayout from '../components/layout/EnterLayout';
import SubmitButton from '../components/Enter/fields/SubmitButton';
import ConfirmModal from '../components/Profile/floating/ConfirmModal';
import { sendAccountDeletionRequest } from '../utils/api/accountApi';
import { genericErrorMessage } from '../utils/lang/commonErrors';
import { getRefreshToken, removeTokens } from '../utils/auth';
import hooverNoIcon from '../../assets/icons/account-termination/hoover-no.svg';
import styles from './AccountTermination.scss';

const AccountTerminationRoute = () => {
  const intl = useIntl();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleDeletionConfirm = () => {
    setError(undefined);
    setIsLoading(true);

    const refreshToken = getRefreshToken();

    if (!refreshToken) {
      setIsLoading(false);
      removeTokens();
      window.location.reload();

      return;
    }

    sendAccountDeletionRequest(refreshToken).then(
      () => {
        setHasSubmitted(true);
        setModalOpen(false);
        setIsLoading(false);
      },
      (error_) => {
        console.log(error_);
        setError(intl.formatMessage(genericErrorMessage));
        setIsLoading(false);
      },
    );
  };

  return (
    <EnterLayout>
      <div className={styles.container}>
        <img src={hooverNoIcon} width="100" height="75" alt="" />

        <h1 className={styles.title}>
          {hasSubmitted ? (
            <FormattedMessage
              id="accountTermination.submitted.title"
              defaultMessage="Account submitted for termination"
            />
          ) : (
            <FormattedMessage id="accountTermination.title" defaultMessage="Account Termination" />
          )}
        </h1>

        <p className={styles.text}>
          {hasSubmitted ? (
            <FormattedMessage
              id="accountTermination.submitted.text"
              defaultMessage="You will receive email confirmation once your account has been deleted. If you have any questions, please contact <supportLink>our support team</supportLink>."
              values={{
                supportLink: (chunks: string) => <a href="https://support.clearvpn.com/hc/requests/new">{chunks}</a>,
              }}
            />
          ) : (
            <FormattedMessage
              id="accountTermination.text"
              defaultMessage="According to our <policyLink>Privacy Policy</policyLink> you can request your account and related data to be deleted Upon your request submission, your account will be deleted within 30 days."
              values={{
                policyLink: (chunks: string) => <a href="https://clearvpn.com/privacy-policy/">{chunks}</a>,
              }}
            />
          )}
        </p>

        {!hasSubmitted && (
          <SubmitButton
            className={styles.button}
            text={intl.formatMessage({
              id: 'accountTermination.requestButton',
              defaultMessage: 'Request account termination',
            })}
            onSubmit={() => {
              setModalOpen(true);
            }}
          />
        )}
      </div>

      <ConfirmModal
        isOpen={isModalOpen}
        isLoading={isLoading}
        error={error}
        title={intl.formatMessage({
          id: 'accountTermination.confirmModal.title',
          defaultMessage: 'Delete account?',
        })}
        confirmButtonText={intl.formatMessage({
          id: 'accountTermination.confirmModal.deleteButton',
          defaultMessage: 'Delete',
        })}
        onConfirm={handleDeletionConfirm}
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </EnterLayout>
  );
};

export default AccountTerminationRoute;
